export enum SORTING_ORDER {
  ASC = "asc",
  DESC = "desc",
}